import { FunctionDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const UseLookupAction = () => (
  <FunctionDocs entry="useLookupAction">
    <ComponentExample
      name="Get lookup action data"
      import={import("examples/Lookups/UseLookupAction/UseLookupActionExample")}
      rawImport={import(
        "examples/Lookups/UseLookupAction/UseLookupActionExample?raw"
      )}
    />
    <ComponentExample
      name="Lookup action with params"
      import={import(
        "examples/Lookups/UseLookupAction/UseLookupActionParamsExample"
      )}
      rawImport={import(
        "examples/Lookups/UseLookupAction/UseLookupActionParamsExample?raw"
      )}
    />
  </FunctionDocs>
);

export default UseLookupAction;
